import { render, staticRenderFns } from "./DataInherit.vue?vue&type=template&id=3f903594&scoped=true"
import script from "./DataInherit.vue?vue&type=script&lang=js"
export * from "./DataInherit.vue?vue&type=script&lang=js"
import style0 from "./DataInherit.vue?vue&type=style&index=0&id=3f903594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f903594",
  null
  
)

export default component.exports